import React, { type FC, Fragment } from 'react';

import { AppSidebar } from '@/components/blocks/sidebar/app-sidebar';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Separator } from '@/components/ui/separator';
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@/components/ui/sidebar';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: FC<AppLayoutProps> = ({ children }) => {
  const segments = [] as Array<string>;

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className='group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear'>
          <div className='flex items-center gap-2 px-4'>
            <SidebarTrigger className='-ml-1' />
            <Separator
              orientation='vertical'
              className='mr-2 data-[orientation=vertical]:h-4'
            />
            <Breadcrumb>
              <BreadcrumbList>
                {segments.map((segment, index) => (
                  <Fragment key={segment}>
                    <BreadcrumbItem className='hidden md:block'>
                      <BreadcrumbLink href='#'>{segment}</BreadcrumbLink>
                    </BreadcrumbItem>
                    {index !== segments.length - 1 && (
                      <BreadcrumbSeparator className='hidden md:block' />
                    )}
                  </Fragment>
                ))}
              </BreadcrumbList>
            </Breadcrumb>
          </div>
        </header>
        <main className='m-4 flex h-full flex-col gap-4 overflow-auto'>
          {children}
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default AppLayout;
